import { Form, Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { postMeetingRoomDls } from "../../../api/meeting-rooms/postMeetingRoomDls";
import { getMeetingRoomDls } from "../../../api/meeting-rooms/getMeetingRoomDls";
import { SelectOptionsType } from "../../../utils/select-helpers";
import Input from "antd/es/input/Input";
import HeaderContext from "../../../components/layout/header/header-context/HeaderContext";

interface Props {
  isVisible: boolean;
  handleClose: (refreshData?: boolean) => void;
}

interface State {
  isModalVisible: boolean;
  submitError?: string;
  meetingRoomDlsOptions?: SelectOptionsType[];
}

const AddMeetingRoomDlFormModal: React.FC<Props> = ({
  isVisible,
  handleClose,
}) => {
  const [form] = Form.useForm();
  const { currentUserId } = useContext(HeaderContext);

  const [state, setState] = useState<State>({
    isModalVisible: false,
    submitError: "",
    meetingRoomDlsOptions: [],
  });

  const { isModalVisible, submitError, meetingRoomDlsOptions } = state;

  const handleCancel = () => {
    form.resetFields();
    setState((prevState) => ({
      ...prevState,
      submitError: "",
    }));
    handleClose();
  };

  const handleSubmit = () => {
    setState((prevState) => ({
      ...prevState,
      submitError: "",
    }));
    form
      .validateFields()
      .then((formFields) => {
        console.log("onOk: %o", formFields);
        const payload = {
          name: formFields.meetingRoomDlName,
          clientId: currentUserId,
        };
        console.log("Submitting postMeetingRoomDls :%o", payload);
        postMeetingRoomDls(payload)
          .then((response) => {
            console.log("submitResponse:%o", response);
            if (response?.error) {
              setState((prevState) => ({
                ...prevState,
                submitError: response.error,
              }));
            } else {
              form.resetFields();
              setState((prevState) => ({
                ...prevState,
                submitError: "",
              }));
              handleClose(true);
            }
          })
          .catch((err) => {
            setState((prevState) => ({
              ...prevState,
              submitError: err,
            }));
            console.log("<EditNumberAssignmentFormModal/> Err:%o", err);
          });
      })
      .catch((err) => {
        console.log("onOk err: %o", err);
      });
  };

  useEffect(() => {
    if (isVisible !== isModalVisible) {
      setState((prevState) => ({
        ...prevState,
        isModalVisible: isVisible,
      }));

      if (!isVisible) return;

      getMeetingRoomDls().then((meetingRoomDlsResponse) => {
        if (meetingRoomDlsResponse.data) {
          console.log("meetingRoomDlsResponse: %o", meetingRoomDlsResponse);
          setState((prevState) => ({
            ...prevState,
            meetingRoomDlsOptions: meetingRoomDlsResponse.data,
          }));
        }
      });
    }
  }, [isVisible, isModalVisible]);

  return (
    <Modal
      title="Add Meeting Room DL"
      maskClosable={false}
      open={isModalVisible}
      onCancel={handleCancel}
      cancelText="Cancel"
      okText="Submit"
      onOk={handleSubmit}
      okButtonProps={{
        className: "bdo-red-button-modal",
      }}
      cancelButtonProps={{
        className: "bdo-grey-button-modal",
      }}
    >
      <div className="my-4" />
      <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
        <Form.Item
          name="meetingRoomDlName"
          label="Meeting Room DL Name:"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            { required: true, message: "This field is required" },
            {
              validator: (_, value) => {
                if (
                  value &&
                  meetingRoomDlsOptions?.some(
                    (option) =>
                      option.label.toLowerCase().trim() ===
                      value.toLowerCase().trim()
                  )
                ) {
                  return Promise.reject("Meeting room DL already exists");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Enter a name" />
        </Form.Item>
        {/* <Form.Item
          name="meetingRoomDlName"
          label="Meeting Room DL Name:"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          rules={[
            { required: true, message: "Select a DL" },
            {
              validator: (_, value) => {
                if (
                  value &&
                  meetingRoomDlsOptions?.some(
                    (option) => option.label === value
                  )
                ) {
                  return Promise.reject("Meeting room DL already exists");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <AutoComplete
            placeholder="Select a DL"
            onChange={() => {}}
            options={getLabelsAsValues(meetingRoomDlsOptions)}
            filterOption={(inputValue, option) =>
              option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
          ></AutoComplete>
        </Form.Item> */}
      </Form>
      {submitError && <div className="text-red-500">{submitError}</div>}
    </Modal>
  );
};

export default AddMeetingRoomDlFormModal;
